module.exports = __webpack_public_path__ + "img/Evacuation_1-sq.08dff07d.svg";